// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"535":"login","830":"signup","966":"dashboard"}[chunkId] || chunkId) + "." + {"535":"9e76bf8b","684":"b8977982","830":"daf496a0","966":"054ef835"}[chunkId] + ".css";
};